import axios from 'axios';
import { PARAMS } from '../../const';
import {
  API_BACKOFFICE_BOOK_GRADES,
  API_BACKOFFICE_UNIT_GRADES,
  API_BACKOFFICE_LESSON_GRADES
} from '../../services/api/apiConst';
import { getLogger } from '../logger';

const debug = getLogger('services:api:external:cmi5Api');

//----------------------------------------------------------------------------------------------------------------------
export let getBookUnitsGrades = book => {
  if (book) {
    let url = API_BACKOFFICE_BOOK_GRADES.replace(PARAMS.SECTION, book.sectionId).replace(PARAMS.BOOK, book.activityId);
    return axios.get(url);
  }
  debug.error('[getBookUnitsGrades] required params not found ');
};

export let getUnitLessonsGrades = unit => {
  if (unit) {
    let url = API_BACKOFFICE_UNIT_GRADES.replace(PARAMS.SECTION, unit.sectionId).replace(
      PARAMS.UNIT,
      unit.id || unit.activityId
    );
    return axios.get(url);
  }
  debug.error('[getUnitLessonsGrades] required params not found ');
};

export let getLessonActivitiesGrades = lesson => {
  if (lesson) {
    let url = API_BACKOFFICE_LESSON_GRADES.replace(PARAMS.SECTION, lesson.sectionId).replace(
      PARAMS.LESSON,
      lesson.id || lesson.activityId
    );
    return axios.get(url);
  }
  debug.error('[getUnitActivitiesGrades] required params not found ');
};
